<template>
  <v-card class="pa-2" outlined tile>
    <h4>Statistika učlanjivanja</h4>

    <div v-if="!loading && Object.keys(memberActivationStats).length !== 0">
      <v-select
        class="year-selector"
        :items="membershipYears"
        v-model="selectedYear"
        dense
      ></v-select>

      <Bar
        :chart-options="{
          responsive: true,
          backgroundColor: '#1976d2',
          plugins: {
            legend: {
              display: false,
            },
          },
        }"
        :chart-data="chartData"
        :height="chartHeight"
      />
    </div>

    <div v-if="!loading && Object.keys(memberActivationStats).length !== 0">
      <Bar
        :chart-options="{
          responsive: true,
          backgroundColor: '#1976d2',
          plugins: {
            legend: {
              display: false,
            },
            zoom: {
              pan: {
                enabled: true,
                mode: 'x',
              },
            },
          },
          scales: {
            x: {
              min: minYear,
            },
          },
        }"
        :chart-data="chartDataWholeHistory"
        :height="chartHeight"
      />
    </div>

    <div v-if="loading">
      <v-progress-circular indeterminate color="#1358a3"></v-progress-circular>
    </div>

    <p v-show="error" class="error-text">{{ error }}</p>
  </v-card>
</template>

<script>
import apiRequest from "../../helpers/apiRequest";
import { Bar } from "vue-chartjs/legacy";
import zoomPlugin from "chartjs-plugin-zoom";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  zoomPlugin
);

export default {
  name: "ActivityGraph",

  components: {
    Bar,
  },

  data() {
    return {
      memberActivationStats: {},
      loading: false,
      error: false,
      selectedYear: new Date().getFullYear(),
      chartHeight: 150,
    };
  },

  async created() {
    await this.getMemberActivationStats();
  },

  computed: {
    chartData() {
      const labels = [
        "Siječanj",
        "Veljača",
        "Ožujak",
        "Travanj",
        "Svibanj",
        "Lipanj",
        "Srpanj",
        "Kolovoz",
        "Rujan",
        "Listopad",
        "Studeni",
        "Prosinac",
      ];

      let membershipsPerMonth = [];

      for (let i = 1; i <= 12; i++) {
        let monthData = this.memberActivationStats.filter((el) => {
          return (
            (el.membershipYear == this.selectedYear &&
              el.year == this.selectedYear &&
              el.month == i) ||
            // Give other year results to January because most of them are Zauvik Član who were activated in December
            (i === 1 &&
              el.membershipYear == this.selectedYear &&
              el.year != this.selectedYear)
          );
        });

        membershipsPerMonth.push(
          monthData.length
            ? monthData.reduce(
                (partialSum, data) => partialSum + data.members_count,
                0
              )
            : 0
        );
      }

      return { labels, datasets: [{ data: membershipsPerMonth }] };
    },

    chartDataWholeHistory() {
      const labels = [...this.membershipYears].reverse();

      let membershipsPerYear = [];

      for (let year of labels) {
        let sum = 0;

        for (let i = 1; i <= 12; i++) {
          let monthData = this.memberActivationStats.filter((el) => {
            return (
              (el.membershipYear == year && el.year == year && el.month == i) ||
              // Give other year results to January because most of them are Zauvik Član who were activated in December
              (i === 1 && el.membershipYear == year && el.year != year)
            );
          });

          if (monthData.length) {
            sum += monthData.reduce(
              (partialSum, data) => partialSum + data.members_count,
              0
            );
          }
        }

        membershipsPerYear.push(sum);
      }

      return { labels, datasets: [{ data: membershipsPerYear }] };
    },

    membershipYears() {
      return this.memberActivationStats
        .map((item) => item.year)
        .filter((value, index, self) => self.indexOf(value) === index)
        .sort((a, b) => b - a);
    },

    minYear() {
      if (this.membershipYears && this.membershipYears.length) {
        if (this.membershipYears.length > 10) {
          return this.membershipYears[9];
        } else {
          return this.membershipYears[this.membershipYears.length - 1];
        }
      } else {
        return new Date().getFullYear() - 10;
      }
    },
  },

  methods: {
    async getMemberActivationStats() {
      this.loading = true;
      this.error = false;

      try {
        this.memberActivationStats = await apiRequest(
          "get",
          "dphs/me/membership-activation-stats"
        );
      } catch (error) {
        this.error = error.response.data.message;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.year-selector {
  float: right;
  margin-top: -1.4em;
  width: 30%;
}
</style>
